<div
  class="notification-item"
  [class.unread]="!notification.readAt"
  [class.notification-item--destructive]="notificationTone() === 'destructive'"
  role="button"
  tabindex="0"
  (click)="handleClick()"
  (keydown)="handleKeydown($event)">

  <span class="item-unread-marker" aria-hidden="true">
    <span *ngIf="!notification.readAt" class="unread-dot"></span>
  </span>

  <div class="item-avatar">
    <app-member-avatar
      *ngIf="actorIdentity"
      [identity]="actorIdentity"
      size="sm"
      [showTooltip]="false">
    </app-member-avatar>
    <div *ngIf="!actorIdentity" class="avatar-placeholder">
      <i nz-icon [nzType]="notificationTypeIcon()" nzTheme="outline"></i>
    </div>
  </div>

  <div class="item-content">
    <div class="item-top">
      <h4 class="item-title">{{ notification.title }}</h4>
      <span class="item-time">{{ formatTime(notification.createdAt) }}</span>
    </div>

    <app-mention-text
      class="item-body"
      *ngIf="notification.body"
      [text]="notification.body"
      [clickable]="false">
    </app-mention-text>

    <div class="item-meta" *ngIf="showSeverity()">
      <span class="meta-pill" [attr.data-intent]="notificationTone()">
        <i nz-icon [nzType]="severityIcon()"></i>
        {{ severityLabel() }}
      </span>
    </div>
  </div>

  <div class="item-actions">
    <button
      nz-button
      nzType="text"
      nzSize="small"
      type="button"
      class="mark-read-toggle  desktop-button"
      nz-tooltip
      [nzTooltipTitle]="notification.readAt ? ('auto.mark.as.unread' | translate) : ('auto.mark.as.read' | translate)"
      (click)="toggleRead($event)"
      [attr.aria-label]="notification.readAt ? ('auto.mark.as.unread' | translate) : ('auto.mark.as.read' | translate)">
      <i nz-icon [nzType]="notification.readAt ? 'mail' : 'check'"></i>
    </button>
  </div>
</div>
